var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEventUpcoming = function SvgEventUpcoming(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "event-upcoming_svg__svg-icon",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16 21v-2h4V9H6v4H4V3h3V1h2v2h8V1h2v2h3v18zm-7 2-1.4-1.4 2.575-2.6H2v-2h8.175L7.6 14.4 9 13l5 5zM6 7h14V5H6zm0 0V5z"
  })));
};
export { SvgEventUpcoming as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBkPSJNMTYgMjFWMTlIMjBWOUg2VjEzSDRWM0g3VjFIOVYzSDE3VjFIMTlWM0gyMlYyMUgxNlpNOSAyM0w3LjYgMjEuNkwxMC4xNzUgMTlIMlYxN0gxMC4xNzVMNy42IDE0LjRMOSAxM0wxNCAxOEw5IDIzWk02IDdIMjBWNUg2VjdaTTYgN1Y1VjdaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz48L3N2Zz4=";